import { render, staticRenderFns } from "./Minimize.vue?vue&type=template&id=06f4574b&scoped=true&"
import script from "./Minimize.vue?vue&type=script&lang=js&"
export * from "./Minimize.vue?vue&type=script&lang=js&"
import style0 from "./Minimize.vue?vue&type=style&index=0&id=06f4574b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f4574b",
  null
  
)

export default component.exports